module.exports = __webpack_public_path__ + "img/MUSA-16.5ab99f7b.jpg";